import io from "socket.io-client";
import { useMemo } from "react";
import { DOMAIN } from "./services/constant";
const REACT_APP_WS_URL = DOMAIN;

let newSocket: any;
const SocketIO = () => {
  try {
    const socket = io(String(REACT_APP_WS_URL), {
      transports: ["websocket"]
    });

    socket.on("connect", () => {
      console.log(" Socket connected");
    });

    socket.on("connect_error", (error: any) => {
      console.log("Socket connect_error", error);
    });

    return socket;
  } catch (error) {
    return null;
  }
};
const createSocket = () => {
  let socket: any;
  try {
    socket = io(String(REACT_APP_WS_URL), {
      transports: ["websocket"]
    });

    return socket;
  } catch (err) {
    console.log(err);
    return null;
  }
};
function getSocket() {
  try {
    if (!newSocket) {
      newSocket = createSocket();
      newSocket.on("connect", () => {
        console.log("Socket connected");
      });

      newSocket.on("connect_error", (error: any) => {
        console.log("Socket connect_error", error);
      });
    }

    return newSocket;
  } catch (err) {
    console.log(err);
    return null;
  }
}
export const useSocketIO = () => {
  const io = useMemo(() => {
    return getSocket();
  }, []);

  return { socketIO: io, id: io?.id || "noid" };
};

export default SocketIO;
